import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useLoginState } from '#src/app/shared/hooks/session';

import type { PromoteFormData } from '../../formData';

type Result = {
	amount: number;
	email: string;
	name: string;
	firstName: string;
	lastName: string;
	isPublic: boolean;
	shouldSavePaymentMethod: boolean;
};

export function useStateInitData(params: PromoteFormData): Result {
	const { cookies } = useUtilityContext();
	const loginState = useLoginState();

	const isSecureGuest = !!(loginState === 'GUEST' && params.featureConfigs.doubleOptinEnabledNewUser);
	const petitionPublicSignatureCookie = cookies.get(`app_meta_public_signature_${params.petition.id}`);

	const isPublic = isSecureGuest ? false : !!petitionPublicSignatureCookie;

	return {
		amount: params.amountChoices[0].amount,
		email: params.user.email,
		name: params.user.name,
		firstName: params.user.firstName,
		lastName: params.user.lastName,
		isPublic,
		shouldSavePaymentMethod: !isSecureGuest,
	};
}
